import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { Animated, Easing, Platform } from 'react-native';
import StyleInterpolator from './StackViewStyleInterpolator';
import { supportsImprovedSpringAnimation } from '../../utils/ReactNativeFeatures';
var IOSTransitionSpec;

if (supportsImprovedSpringAnimation()) {
  IOSTransitionSpec = {
    timing: Animated.spring,
    stiffness: 1000,
    damping: 500,
    mass: 3,
    overshootClamping: true,
    restDisplacementThreshold: 0.01,
    restSpeedThreshold: 0.01
  };
} else {
  IOSTransitionSpec = {
    duration: 500,
    easing: Easing.bezier(0.2833, 0.99, 0.31833, 0.99),
    timing: Animated.timing
  };
}

var SlideFromRightIOS = {
  transitionSpec: IOSTransitionSpec,
  screenInterpolator: StyleInterpolator.forHorizontal,
  containerStyle: {
    backgroundColor: '#eee'
  }
};
var ModalSlideFromBottomIOS = {
  transitionSpec: IOSTransitionSpec,
  screenInterpolator: StyleInterpolator.forVertical,
  containerStyle: {
    backgroundColor: '#eee'
  }
};
var FadeInFromBottomAndroid = {
  transitionSpec: {
    duration: 350,
    easing: Easing.out(Easing.poly(5)),
    timing: Animated.timing
  },
  screenInterpolator: StyleInterpolator.forFadeFromBottomAndroid
};
var FadeOutToBottomAndroid = {
  transitionSpec: {
    duration: 150,
    easing: Easing.in(Easing.linear),
    timing: Animated.timing
  },
  screenInterpolator: StyleInterpolator.forFadeToBottomAndroid
};
var NoAnimation = {
  transitionSpec: {
    duration: 0,
    timing: Animated.timing
  },
  screenInterpolator: StyleInterpolator.forNoAnimation,
  containerStyle: {
    backgroundColor: '#eee'
  }
};

function defaultTransitionConfig(transitionProps, prevTransitionProps, isModal) {
  if (Platform.OS !== 'ios') {
    if (prevTransitionProps && transitionProps.index < prevTransitionProps.index) {
      return FadeOutToBottomAndroid;
    }

    return FadeInFromBottomAndroid;
  }

  if (isModal) {
    return ModalSlideFromBottomIOS;
  }

  return SlideFromRightIOS;
}

function getTransitionConfig(transitionConfigurer, transitionProps, prevTransitionProps, isModal) {
  var defaultConfig = defaultTransitionConfig(transitionProps, prevTransitionProps, isModal);

  if (transitionConfigurer) {
    return _objectSpread({}, defaultConfig, transitionConfigurer(transitionProps, prevTransitionProps, isModal));
  }

  return defaultConfig;
}

export default {
  defaultTransitionConfig: defaultTransitionConfig,
  getTransitionConfig: getTransitionConfig,
  SlideFromRightIOS: SlideFromRightIOS,
  ModalSlideFromBottomIOS: ModalSlideFromBottomIOS,
  FadeInFromBottomAndroid: FadeInFromBottomAndroid,
  FadeOutToBottomAndroid: FadeOutToBottomAndroid,
  NoAnimation: NoAnimation
};